import { OrderedProduct } from './dto';

export const formatPrice = (priceInCents: number) => {
  const price = (Math.trunc(priceInCents) / 100).toFixed(2);
  return `${price} €`.replace('.', ',');
};

export const getOrderedProductsPrice = (products: OrderedProduct[]) =>
  products.reduce((previousValue, currentValue) => previousValue + currentValue.price, 0);
